/**
 * Date rendering for order copy.
 *
 * `toLocaleDateString` takes the month name and the field order straight from
 * the platform's locale data, so none of this is translated copy — there are no
 * `orderList.*` keys for months and nothing for Crowdin to carry. What matters
 * is that the locale reaching it is the real one; every call site used to pass
 * `'en-US'` literally, which is why orders read in English months everywhere.
 */

/** Order card and detail header: `Mon, Sep 15, 2026`. */
export const ORDER_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
}

/** Order list title: `September 15, 2026`. */
export const ORDER_DATE_LONG_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}

/**
 * Formats an ISO date for display in `locale`.
 *
 * An unparseable date returns the input untouched rather than the
 * `Invalid Date` that `toLocaleDateString` would otherwise render into the UI.
 */
export function formatOrderDate(
  isoDate: string,
  locale: string,
  options: Intl.DateTimeFormatOptions = ORDER_DATE_FORMAT,
): string {
  const date = new Date(isoDate)

  if (Number.isNaN(date.getTime())) return isoDate

  return date.toLocaleDateString(locale, options)
}
